import { render, staticRenderFns } from "./ComponentList_new.vue?vue&type=template&id=fc2106c2"
import script from "./ComponentList_new.vue?vue&type=script&lang=ts"
export * from "./ComponentList_new.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports